/**
 * lib/donate-targets — КОНФИГ крипто-адресов приёма донатов (ЕДИНЫЙ источник).
 *
 * ЗАЧЕМ / WHY THIS EXISTS (CLAUDE.md hard-rule «константы — в config, не в логике»):
 * адреса/сети живут ОДНИМ массивом здесь, экран «Поддержать» и примитив
 * `components/crypto-receive-card` их только читают. Добавить/сменить сеть = правка
 * ЭТОГО файла, без касания экрана/примитива (модульность). Порядок массива = порядок
 * показа карт (owner-directive 2026-06-26: USDT первой — практичнее для маленьких
 * донатов и emerging-markets; затем Ethereum/EVM, затем Bitcoin).
 *
 * `title`/`network` — БРЕНД/ТИКЕРЫ (имена сетей и монет: USDT, TRON, Ethereum, BTC) —
 * одинаковы во всех языках, поэтому НЕ в каталоге i18n (это не переводимый UI-текст, а
 * имена собственные). Локализуется только обвязка экрана (см. game.support.* каталог).
 *
 * УРОВЕНЬ L0 (ADR-0024 addendum §8): статичный адрес + QR + копирование. Сайт НЕ держит
 * ключей, НЕ верифицирует платёж, НЕТ wallet-connect — деньги идут напрямую игрок→кошелёк.
 * Донат НЕ даёт игрового преимущества (no pay-to-win) → сервер о платеже не знает.
 *
 * Cross-references: ADR-0024-crypto-receive-telegram-ton/addendum-eth-donations.md §7/§8;
 *   screens/support-screen; components/crypto-receive-card.
 */

/** Одна цель приёма (карта). Адрес — публичный, раскрывать безопасно (ADR-0024 §3). */
export interface DonateTarget {
  /** Стабильный id (адресация в тестах/стилях, ключ QR-кэша). */
  readonly id: string;
  /** Заголовок карты — имя сети/монеты (бренд, не локализуется). */
  readonly title: string;
  /** Под-строка — сеть и/или принимаемые монеты (бренд/тикеры, не локализуется). */
  readonly network: string;
  /** Публичный адрес приёма. */
  readonly address: string;
}

/**
 * Цели приёма донатов. Порядок = порядок показа (USDT-первой, owner 2026-06-26).
 * Адреса — owner-provided (2026-06-26).
 */
export const DONATE_TARGETS: readonly DonateTarget[] = [
  {
    id: 'usdt-tron',
    title: 'USDT',
    network: 'TRON / TRC20',
    address: 'TMsZPi41UhhfarwYgRm2PzdzAgZQrnkXAu',
  },
  {
    id: 'evm',
    title: 'ETH / USDT / USDC',
    network: 'Ethereum / ERC20',
    address: '0x936f14B4725ff251c94c3De177d7B06F02BcDF3E',
  },
  {
    id: 'btc',
    title: 'BTC',
    network: 'Bitcoin',
    address: 'bc1qf3zqmaek4jx4gqqjgq7gha674m622udc7gy24n',
  },
];
